import React from 'react';
import PropTypes from 'prop-types';
import cx from 'classnames';
import {FormattedMessage} from 'react-intl';

import {Button} from '@stubhub/bamboo';
import {formatURLDomain} from '@stubhub/sh-url-utils';

import CheckoutIntegrationHoc from '../react-checkout-integration';

const CheckoutButton = ({checkoutParamsString = '', className, hrefPrefix, onClick}, {globalRegistry}) => {
  const defaultLocale = globalRegistry?.getDefaultLocale();
  const currentLocale = globalRegistry?.getCurrentLocale();

  const handleClick = (event) => {
    return onClick && onClick(event);
  };

  const url = formatURLDomain({href: `${hrefPrefix}?${checkoutParamsString}`, defaultLocale, currentLocale});

  return (
    <Button href={url} onClick={handleClick} className={cx('Button_pill', className)}>
      <FormattedMessage id="BuildYourOrder.checkoutText" defaultMessage="Buy Now" />
    </Button>
  );
};

CheckoutButton.propTypes = {
  /* URL params string  */
  checkoutParamsString: PropTypes.string,

  /* onClick event */
  onClick: PropTypes.func,

  /* Css class name */
  className: PropTypes.string,

  /* Href */
  hrefPrefix: PropTypes.string,
};

CheckoutButton.contextTypes = {
  globalRegistry: PropTypes.object,
};

export default CheckoutIntegrationHoc(CheckoutButton);
export {CheckoutButton};
